"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.multiProductsOptions = exports.productsOptions = void 0;
exports.productsOptions = [
    'iPhone', 'Watch', 'iMac', 'Mac Pro', 'MacBook Air', 'MacBook Pro',
];
exports.multiProductsOptions = [
    { value: 'iphone', label: 'iPhone' },
    { value: 'watch', label: 'Watch' },
    { value: 'imac', label: 'iMac' },
    { value: 'macpro', label: 'Mac Pro' },
    { value: 'macbookair', label: 'MacBook Air' },
    { value: 'macbookpro', label: 'MacBook Pro' },
];
